import { config } from "@/utils/configuration/config";
import { shipPartsElements } from "@/utils/constants";
import store from "@/store/index";
import ShipPartRepoStatic from "@/repositories/shipPart/ShipPartRepoStatic";
import ShipPartRepoFirebase from "@/repositories/shipPart/ShipPartRepoFirebase";
import CalcAttainedEEXIService from "@/services/CalcAttainedEEXIService";
import Configuration from "@/model/Configuration";
import Ship from "@/model/Ship";

class ShipPartService {
  private shipPartRepo: any;
  private static instance: ShipPartService;

  private constructor() {
    // Se obtiene el valor de la configuración para saber si hay que utilizar firebase o se
    // van a utilizar datos estáticos de prueba
    if (!config.app.useFirebase) {
      this.shipPartRepo = new ShipPartRepoStatic();
    } else {
      this.shipPartRepo = new ShipPartRepoFirebase();
    }
  }

  public static getInstance() {
    console.log("ShipPartService - getInstance");
    if (!ShipPartService.instance) {
      ShipPartService.instance = new ShipPartService();
    }

    return ShipPartService.instance;
  }

  public getShipPartFromConfiguration(ship, configurationId) {
    shipPartsElements.forEach((configuration) => {
      ship.configurations.forEach((confInShip) => {
        if (confInShip.id === configurationId) {
          confInShip[configuration] = [];
        }
      });

      this.shipPartRepo.getConfigurationChilds(ship, configurationId, this, configuration);
    });
  }

  public addNewShipPartFromRepo(ship, configurationId, collectionConfigurationChild, id, obj) {
    // console.log("ShipParts añadido a elemento", configurationId, "de tipo", collectionConfigurationChild, "en buque", ship)
    ship.configurations.forEach((confInShip) => {
      if (confInShip.id === configurationId) {
        const newShipPart = {
          id: id,
          ...obj,
        };

        const currentConfigurationObj = store.getters.currentConfiguration;
        console.log(
          "store.getters.currentConfiguration",
          currentConfigurationObj,
          ". configurationId",
          configurationId
        );
        if (currentConfigurationObj.id === configurationId) {
          currentConfigurationObj[collectionConfigurationChild].push(newShipPart);
          console.log("Se ha modificado la configuración que estamos editando", currentConfigurationObj);
          store.commit("SET_SHIPS_CURRENT_CONFIGURATION", currentConfigurationObj);
        } else {
          confInShip[collectionConfigurationChild].push(newShipPart);
        }
      }
    });
  }

  public modifyShipPartFromRepo(ship, configurationId, collectionConfigurationChild, id, obj) {
    console.log("modifyShipPartFromRepo", obj);
    ship.configurations.forEach((confInShip) => {
      if (confInShip.id === configurationId) {
        console.log("encontrada la configuración afectada");
        const pos = confInShip[collectionConfigurationChild].map((val) => val.id).indexOf(id);
        if (pos >= 0) {
          console.log(
            "encontrado el shipPart afectado. Antes del cambio:",
            confInShip[collectionConfigurationChild][pos]
          );

          // eslint-disable-next-line no-unused-vars
          const newShipPart = {
            id: id,
            ...obj,
          };

          confInShip[collectionConfigurationChild][pos] = newShipPart;

          console.log(
            "encontrado el shipPart afectado. Después del cambio:",
            confInShip[collectionConfigurationChild][pos]
          );
        }

        console.log(
          "store.getters.currentConfiguration",
          store.getters.currentConfiguration,
          ". configurationId",
          configurationId
        );
        if (store.getters.currentConfiguration.id === configurationId) {
          console.log("Se ha modificado la configuración que estamos editando", confInShip);
          store.commit("SET_SHIPS_CURRENT_CONFIGURATION", confInShip);
        }
      }
    });
  }

  public removedShipPartFromRepo(ship, configurationId: string, shipPartType: string, id: string) {
    console.log("removedShipPartFromRepo");
    ship.configurations.forEach((confInShip) => {
      if (confInShip.id === configurationId) {
        console.log("encontrada la configuración afectada");
        const pos = confInShip[shipPartType].map((val) => val.id).indexOf(id);
        if (pos >= 0) {
          confInShip[shipPartType].splice(pos, 1);

          console.log("Después de borrar:", confInShip[shipPartType]);
        }
        if (store.getters.currentConfiguration.id === configurationId) {
          console.log("Se borrado un elemento en la configuración que estamos editando", confInShip);
          store.commit("SET_SHIPS_CURRENT_CONFIGURATION", confInShip);
        }
      }
    });
  }

  public saveMainEnginePart(ship, configuration, newPart, parametricTables) {
    console.log("ShipPartService.saveMainEnginePart", ship.id, configuration.id);

    const shipPartToSave = CalcAttainedEEXIService.calcMainEngineAttainedValue(
      parametricTables,
      newPart,
      ship,
      configuration
    );
    console.log("New CalcAttainedEEXIService result", shipPartToSave);

    let errors = "";
    if (newPart.id && newPart.id !== "") {
      errors = this.shipPartRepo.editPart(ship.id, configuration.id, "MainEngineEmissions", shipPartToSave);
    } else {
      delete shipPartToSave.id;
      errors = this.shipPartRepo.saveNewPart(ship.id, configuration.id, "MainEngineEmissions", shipPartToSave);
    }
    return errors;
  }

  public cloneShipPart(shipId, configurationId, newPart, shipPartToSave) {
    const errors = this.shipPartRepo.saveNewPart(shipId, configurationId, newPart, shipPartToSave);
    return errors;
  }

  public saveAuxEnginePart(shipId, configurationId, newPart, parametricTables, shipType, shipGt, currentConfiguration) {
    console.log("ShipPartService.saveAuxEnginePart", shipId, configurationId, newPart);

    const shipPartToSave = CalcAttainedEEXIService.calcAuxEngineAttainedValue(
      parametricTables,
      newPart,
      shipType,
      shipGt,
      currentConfiguration
    );
    console.log("New CalcAttainedEEXIService result", shipPartToSave);

    let errors = "";
    if (newPart.id && newPart.id !== "") {
      errors = this.shipPartRepo.editPart(shipId, configurationId, "AuxiliaryEngineEmissions", shipPartToSave);
    } else {
      delete shipPartToSave.id;
      errors = this.shipPartRepo.saveNewPart(shipId, configurationId, "AuxiliaryEngineEmissions", shipPartToSave);
    }
    return errors;
  }

  public saveMainEngineEnergySavingsPart(ship: Ship, configuration: Configuration, newPart) {
    console.log("ShipPartService.saveMainEngineEnergySavingsPart", ship.id, configuration.id, newPart);

    const shipPartToSave = CalcAttainedEEXIService.calcMainEngineEnergySavingsAttainedValue(newPart, configuration);
    console.log("New CalcAttainedEEXIService result", shipPartToSave);

    let errors = "";
    if (newPart.id && newPart.id !== "") {
      errors = this.shipPartRepo.editPart(ship.id, configuration.id, "MainEngineEnergySavings", shipPartToSave);
    } else {
      delete shipPartToSave.id;
      errors = this.shipPartRepo.saveNewPart(ship.id, configuration.id, "MainEngineEnergySavings", shipPartToSave);
    }
    return errors;
  }

  public saveAuxEngineEnergySavingsPart(shipId, configurationId, newPart) {
    console.log("ShipPartService.saveAuxEngineEnergySavingsPart", shipId, configurationId, newPart);

    const shipPartToSave = CalcAttainedEEXIService.calcAuxEngineEnergySavingsAttainedValue(newPart);
    console.log("New CalcAttainedEEXIService result", shipPartToSave);

    let errors = "";
    if (newPart.id && newPart.id !== "") {
      errors = this.shipPartRepo.editPart(shipId, configurationId, "AuxiliaryEngineEnergySavings", shipPartToSave);
    } else {
      delete shipPartToSave.id;
      errors = this.shipPartRepo.saveNewPart(shipId, configurationId, "AuxiliaryEngineEnergySavings", shipPartToSave);
    }
    return errors;
  }

  public deleteShipPart(shipId: string, configurationId: string, shipPartType: string, shipPartId: string) {
    console.log("ShipPartService.deleteShipPart", shipId, configurationId, shipPartType, shipPartId);
    this.shipPartRepo.deleteShipPart(shipId, configurationId, shipPartType, shipPartId);
  }
}

export default ShipPartService;
